import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const Subtitle = ({
  className,
  children,
  as = 'h5',
  stickyToTop = true,
  style,
  ...props
}) => {
  const Container = as;

  return (
    <Container
      {...props}
      style={{
        ...style,
        '--top-offset': isObject(stickyToTop) ? stickyToTop.topOffset ?? 0 : 0,
      }}
      className={cn(styles.root, className, {
        [styles.stickyToTop]: Boolean(stickyToTop),
      })}
    >
      {children}
    </Container>
  );
};

export default Subtitle;

function isObject(value) {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
